export default __webpack_public_path__ + "static/media/noNews.e27bcad9.png";